import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const OverallDistributionChart = ({
  chartData = {},
  // cumulative_grade_distribution = "",
  cumulative_grade,
}) => {
  const labels = ["A+", "A", "B+", "B", "C+", "C", "D"];

  const normalizedData = Object.entries(chartData).reduce(
    (acc, [grade, count]) => {
      const mappedGrade = grade === "U" || grade === "E" ? "D" : grade;
      acc[mappedGrade] = (acc[mappedGrade] || 0) + count;
      return acc;
    },
    {}
  );

  // const dataValues = labels.map((label) => chartData[label] || 0);
  const dataValues = labels.map((label) => normalizedData[label] || 0);

  // const backgroundColors = labels.map((label) =>
  //   label === cumulative_grade ? "#50B6F2" : "#D3D3D3"
  // );

  const backgroundColors = labels.map((label) =>
    label === cumulative_grade ||
    (cumulative_grade === "U" && label === "D") ||
    (cumulative_grade === "E" && label === "D")
      ? "#50B6F2"
      : "#D3D3D3"
  );

  const data = {
    labels,
    datasets: [
      {
        label: "Number of Students",
        data: dataValues,
        backgroundColor: backgroundColors,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 1,
        },
      },
      x: {
        title: {
          display: false,
        },
        ticks: {
          color: (context) => {
            const label = context.tick.label;
            if (
              label === cumulative_grade ||
              (cumulative_grade === "U" && label === "D") ||
              (cumulative_grade === "E" && label === "D")
            ) {
              return "#50B6F2";
            }
            return "#666";
          },
          font: (context) => {
            const label = context.tick.label;
            if (
              label === cumulative_grade ||
              (cumulative_grade === "U" && label === "D") ||
              (cumulative_grade === "E" && label === "D")
            ) {
              return { weight: "bold" };
            }
            return {};
          },
        },
      },
    },
    plugins: {
      legend: { display: false },
      tooltip: { enabled: true },
      title: { display: false },
    },
  };

  return (
    <div style={{ height: "200px", width: "100%", maxWidth: "500px" }}>
      {/* // <div style={{ height: "40vh", width: "100%", maxWidth: "600px" }}> */}
      <Bar data={data} options={options} />
    </div>
  );
};

export default OverallDistributionChart;
